import React, { useState } from "react";

const AdminBlogs = ({ setShowAddBlog }) => {
  const [responseMessage, setResponseMessage] = useState("");
  const [formData, setFormData] = useState({
    blog_title: "",
    blog_description: "",
    blog_image: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      blog_image: e.target.files[0],
    }));
  };

  const handlePostBlog = async (e) => {
    e.preventDefault();

    const form = new FormData();
    for (let key in formData) {
      form.append(key, formData[key]);
    }

    try {
      const response = await fetch("https://api.swalokgroup.com/api/post-blog", {
        method: "POST",
        body: form,
      });
      if (response.ok) {
        setResponseMessage("Blog Posted Successfully");
        setTimeout(() => {
          setResponseMessage("");
          window.location.reload();
        }, 1000);
        setShowAddBlog(false);
      } else {
        setResponseMessage("Failed to post blog. Try again later.");
        setTimeout(() => {
          setResponseMessage("");
        }, 1000);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      <section className="py-4">
        <div className="profile-area-inner">
          <p className="profile-heading">Post A Blog</p>

          <form className="row g-3 py-4 px-4" onSubmit={handlePostBlog}>
            <div className="col-12">
              <label htmlFor="Blog Title" className="text-muted">
                Blog Title
              </label>
              <input
                type="text"
                className="form-input"
                name="blog_title"
                value={formData.blog_title}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-12">
              <label htmlFor="Description" className="text-muted">
                Description
              </label>
              <textarea
                type="text"
                className="form-input"
                name="blog_description"
                value={formData.blog_description}
                onChange={handleChange}
                style={{ height: "8em" }}
                required
              ></textarea>
            </div>
            <div className="col-12 text-start">
              <label htmlFor="Site Image" className="form-label text-muted">
                Upload Blog Image
              </label>
              <input
                type="file"
                className="form-input"
                name="blog_image"
                onChange={handleFileChange}
                required
              />
            </div>

            <div className="col-12 my-4 text-end">
              <button type="submit" className="admin-btn py-2 px-3 rounded">
                Submit
              </button>
            </div>
          </form>
          {/* form ends */}
        </div>
        {responseMessage && (
          <div className="response-message d-flex justify-content-between">
            <p className="my-0 mx-auto">{responseMessage}</p>
            <p
              className="my-0 cursor-pointer"
              onClick={() => setResponseMessage(false)}
            >
              <i className="fa-solid fa-xmark"></i>
            </p>
          </div>
        )}
      </section>
    </>
  );
};

export default AdminBlogs;
